module.exports = __webpack_public_path__ + "img/facebookIcon-dark.ae55ea17.svg";